import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActivityTiming, setRefresh, setSelectedActivity } from "../../store/MahutiReducer";
import { mySteps, myStepsActivity } from "../../utils/stepperUtils";
import MahutiInputTimeItem from "./MahutiInputTimeItem";

function MahutiInputTimeList(props) {

    const selector = useSelector(state => state.reducer);
    const store = useSelector(store => store.reducer);
    const [, setMySelectedActivityTime] = useState({});
    const dispatch = useDispatch();

    const updateActivityTiming = (selectedTiming) => {
        setMySelectedActivityTime(selectedTiming);
        dispatch(setActivityTiming({ ...selectedTiming }));
        myStepsActivity[selector.currentStep].disabled = false;
        mySteps[selector.currentStep].disabled = false;
    }

    const isSelected = (selector, item) => item?.id === selector?.selectedActivity?.timing?.id

    // useEffect(() => {
    //     if (props.activityTimeSlots && props.activityTimeSlots.length === 1) {
    //         updateActivityTiming(props.activityTimeSlots[0]);

    //         myStepsActivity[selector.currentStep].disabled = false;
    //         mySteps[selector.currentStep].disabled = false;
    //     }
    // }, [props.activityTimeSlots])

    useEffect(() => {
        dispatch(setSelectedActivity({ ...store.selectedActivity, visitors: { adults: store.visitors?.adults, underAge: store.visitors?.underAge } }));
        dispatch(setRefresh(false))
    },[])

    return <>
        <div className="time_container">
            <h2 className="almoni_tzar_normal text-start">בחרו שעה</h2>
            <ul className="list-group p-0 py-2">

                {props.activityTimeSlots ? props.activityTimeSlots?.map((item, index) =>
                    <li key={'MahutiInputTimeItem.' + index} className="list-group-item border-0 p-0"><MahutiInputTimeItem length={props.activityTimeSlots.length} lineId={'MahutiInputTimeItem.' + index} activityTime={{ ...item, id: index }}
                        setMyTime={updateActivityTiming} isSelected={isSelected(selector, { ...item, id: index })} /></li>) : <h2 className="alert alert-text">אין זמני הצגה</h2>}
            </ul>
        </div>
    </>
}

export default MahutiInputTimeList;